import { EnvType } from "../services";
import { IApiClient } from "../api-client";
import { LoginOktaRequest } from "../Types/login-okta-request";
import { LoginOktaResponse } from "../Types/login-okta-response";

interface IOktaApiClient {
  Login(request: LoginOktaRequest): Promise<LoginOktaResponse>;
}

export default class OktaApiClient implements IOktaApiClient {
  readonly servicePort = 9522;
  readonly serviceBaseUrl = "okta-service/api";

  oktaApiClient: IApiClient;

  constructor(oktaApiClient: IApiClient, envType: EnvType) {
    this.oktaApiClient = oktaApiClient;
    if (envType === "local") this.oktaApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async Login(request: LoginOktaRequest): Promise<LoginOktaResponse> {
    return await this.oktaApiClient.post<LoginOktaRequest, LoginOktaResponse>(
      `${this.serviceBaseUrl}/login/okta`,
      request
    );
  }

  //------Utils------
  GetApiUrl(): string {
    return this.oktaApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
